import useSWR from 'swr';
import { TeamMember } from '../interfaces';
import { getTeamMemberById } from '../api';
export const useTeamMember = (brokerId?: string) => {
  const key = brokerId ? `/team-member/${brokerId}` : null;
  const {
    data: teamMember,
    isLoading,
    isValidating,
  } = useSWR<TeamMember | undefined>(key, async () => {
    if (!brokerId) {
      return undefined;
    }
    return getTeamMemberById(brokerId);
  });

  return {
    teamMember,
    teamMemberIsLoading: isLoading && isValidating,
  };
};
